import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=64c75f9c&scoped=true&lang=pug&"
import script from "./Message.vue?vue&type=script&lang=coffee&"
export * from "./Message.vue?vue&type=script&lang=coffee&"
import style0 from "./Message.vue?vue&type=style&index=0&id=64c75f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c75f9c",
  null
  
)

component.options.__file = "Message.vue"
export default component.exports